import { render, staticRenderFns } from "./UpcomingEventsTable.vue?vue&type=template&id=4e953c28&"
import script from "./UpcomingEventsTable.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventsTable.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports